import React from 'react';
import { Link } from 'react-router-dom';
import TopNav from '../../components/TopNav';
import CatchImage from '../../images/catch/catch.jpg';
import CatchImage2x from '../../images/catch/catch@2x.jpg';
import { useAuthUserContext } from '../../providers/AuthUser';

const Header = () => {
  const { user } = useAuthUserContext();

  return (
    <header>
      <TopNav />
      <div className="catch top">
        <div className="left">
          <p className="numb">ドナー登録数</p>
          <p className="numb"><span>7000</span>人突破！</p>
          <strong><span>精子提供</span>マッチングサービス</strong>
          <p className="txt">Ton Bébéは、精子提供で妊娠を望む全ての方により良い選択をしていただくための精子提供マッチングサービスです。</p>
          <ul>
            { user ? (
              <>
                <li><Link to="/mypage" className="w_bluebtn">マイページ</Link></li>
                <li><Link to="/search-result" className="orangebtn">ドナー検索</Link></li>
              </>
            ) : (
              <>
                <li><Link to="/register" className="bluebtn">無料ではじめる</Link></li>
                <li><Link to="/login" className="w_bluebtn">ログイン</Link></li>
              </>
            ) }
          </ul>
        </div>
        <img
          src={ CatchImage }
          srcSet={ `${ CatchImage } 1x, ${ CatchImage2x } 2x` }
          alt="Ton Bébé"
        />
        <div className="catchcopy">
          <p>子供を望む</p>
          <p>全ての人に</p>
        </div>
      </div>
    </header>
  );
}

export default Header;
